import { render, staticRenderFns } from "./StudentsViewTabInvoices.vue?vue&type=template&id=5a63658a"
import script from "./StudentsViewTabInvoices.vue?vue&type=script&lang=js"
export * from "./StudentsViewTabInvoices.vue?vue&type=script&lang=js"
import style0 from "./StudentsViewTabInvoices.vue?vue&type=style&index=0&id=5a63658a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports